/**
 * Datas do consumo. O campo `<input type="date">` fala "AAAA-MM-DD" e a API fala
 * ISO com hora; a conversão fica num lugar só.
 */

/** Hoje em "AAAA-MM-DD", no fuso do aparelho — o padrão e o teto do campo. */
export function hoje(): string {
  const agora = new Date();
  const mes = String(agora.getMonth() + 1).padStart(2, '0');
  const dia = String(agora.getDate()).padStart(2, '0');
  return `${agora.getFullYear()}-${mes}-${dia}`;
}

/**
 * "AAAA-MM-DD" → instante ISO para a API, ou `undefined` quando é hoje.
 *
 * **Hoje não manda instante nenhum.** O campo é opcional e o servidor carimba
 * o próprio "agora" — que é a autoridade sobre que horas são. Mandar o relógio
 * do aparelho fazia o consumo do dia ser recusado quando o celular estava
 * poucos segundos adiantado em relação ao cluster: "agora" chegava como
 * futuro. Nunca apareceu em desenvolvimento porque ali navegador e servidor
 * compartilham o mesmo relógio.
 *
 * Data passada vira **meio-dia local**. Meio-dia, e não meia-noite, porque a
 * meia-noite de um fuso a leste de Greenwich cai no dia seguinte em UTC.
 */
export function momentoDoConsumo(data: string): string | undefined {
  if (data === hoje()) return undefined;

  const [ano, mes, dia] = data.split('-').map(Number);
  if (!ano || !mes || !dia) return undefined;
  return new Date(ano, mes - 1, dia, 12, 0, 0).toISOString();
}

/** "16 de setembro de 2026" — data por extenso, como se lê. */
export function porExtenso(iso: string | null): string {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('pt-BR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
